import React, { PureComponent } from 'react'
import { arrayOf, shape, string, func } from 'prop-types'
import { createFontStyle } from '@ycos/primitives'
import Markdown from '@ycos/markdown'

const LIST_TYPES = {
  'isc-list-dash': (theme) => {
    const { dashLength, dashHeight } = theme.custom.list

    return {
      paddingLeft: `${dashLength + 3 * theme.spacingMultiplier}px`,
      textAlign: 'left',
      ':before': {
        width: `${dashLength}px`,
        height: `${dashHeight}px`,
        transform: dashHeight > 1 ? 'translateY(-50%)' : undefined
      }
    }
  },
  'isc-list-dot': () => ({
    textAlign: 'left',
    ':before': {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      transform: 'translateY(-50%)'
    }
  })
}

class List extends PureComponent {
  static layoutVariant = ['isc-list-dot', 'isc-list-dash']

  render() {
    const { children, item, onMarkdownTargetClick } = this.props
    return (
      <ul>
        {children.map(({ props }, i) => {
          return (
            <ListItem key={i} type={item.layoutVariant}>
              <Markdown teaserText={props.item.teaserText} onMarkdownTargetClick={onMarkdownTargetClick} />
            </ListItem>
          )
        })}
      </ul>
    )
  }
}

List.propTypes = {
  item: shape({
    layoutVariant: string.isRequired
  }).isRequired,
  onMarkdownTargetClick: func,
  children: arrayOf(
    shape({
      teaserText: string.isRequired
    })
  ).isRequired
}

// as line height is always the same to every breakpoints, we use this
// value to calculate the top offset
const commonStyling = (theme) => {
  const { custom, spacingMultiplier, typography } = theme

  return {
    position: 'relative',
    marginBottom: `${3 * spacingMultiplier}px`,
    paddingLeft: `${5 * spacingMultiplier}px`,
    color: custom.list.color,
    ':before': {
      content: '""',
      position: 'absolute',
      top: `${parseFloat(typography.styles.Paragraph['4'].bp1.lineHeight / 2)}em`,
      left: 0,
      backgroundColor: custom.list.iconColor
    }
  }
}

const ListItem = createFontStyle('ListItem', { type: 'Paragraph', tagName: 'li', name: '4' }, ({ theme, type }) => {
  const common = commonStyling(theme)
  const list = LIST_TYPES[type](theme)

  return {
    ...common,
    ...list,
    ':before': {
      ...common[':before'],
      ...list[':before']
    }
  }
})

export default List
